import { useAppSelector } from '@store/selectors';
import { Scope } from '@tools/enums';
import { checkForScopes } from '@tools/utils';

export const useHasTimeOfUseReadScope = () =>
    checkForScopes([Scope.GRIDX_TIME_OF_USE_READ]);

export const useHasTimeOfUseWriteScope = () =>
    checkForScopes([Scope.GRIDX_TIME_OF_USE_WRITE]);

export const useHasTimeOfUseMotivesReadScope = () =>
    checkForScopes([Scope.GRIDX_TIME_OF_USE_MOTIVES_READ]);

export const useHasTimeOfUseSessionInsightsReadScope = () =>
    checkForScopes([Scope.GRIDX_TIME_OF_USE_SESSION_INSIGHTS_READ]);

export const useHasHomeComfortWebAppBlockerReadScope = () =>
    checkForScopes([Scope.GRIDX_HOME_COMFORT_WEB_APP_BLOCKER_READ]);

export const useIsToUBatteryLocked = () =>
    useAppSelector((state) => state.timeOfUse.batteryOptimizationState?.locked);

export const useIsEnabledOptimization = () =>
    useAppSelector(
        (state) => state.timeOfUse.batteryOptimizationState?.activated,
    );

export const useToUStatus = () =>
    useAppSelector((state) => state.timeOfUse.status);

export const useIsToUBatteryDisabled = () => {
    const hasTimeOfUseWriteScope = useHasTimeOfUseWriteScope();
    const isToUBatteryLocked = useIsToUBatteryLocked();

    return !hasTimeOfUseWriteScope || isToUBatteryLocked;
};

export const useBatteryOptimizationDecisionStatus = () =>
    useAppSelector(
        (state) => state.timeOfUse.batteryOptimizationDecision?.status,
    );

export const useBatteryOptimizationDecision = () =>
    useAppSelector((state) => state.timeOfUse.batteryOptimizationDecision);

export const useOptimizationSession = () =>
    useAppSelector((state) => state.timeOfUse.optimizationSession);

export const useBatteryOptimizationAggregations = () =>
    useAppSelector(
        (state) => state.timeOfUse.optimizationSession?.aggregations?.battery,
    );

export const useBatteryOptimizationSessions = () =>
    useAppSelector((state) => state.timeOfUse.optimizationSession?.sessions);

export const useHasToUError = () =>
    useAppSelector((state) => {
        return (
            state.energy.gatewayDevice &&
            state.energy.gatewayDevice.deviceConfiguration &&
            Object.prototype.hasOwnProperty.call(
                state.energy.gatewayDevice?.deviceConfiguration,
                'ToU',
            ) &&
            // @ts-ignore
            !state.energy.gatewayDevice?.deviceConfiguration?.ToU
        );
    });

export const useIsMigratedSystem = () =>
    useAppSelector((state) => {
        return (
            state.energy.gatewayDevice &&
            state.energy.gatewayDevice.deviceConfiguration &&
            Object.prototype.hasOwnProperty.call(
                state.energy.gatewayDevice?.deviceConfiguration,
                'hasBeenMigrated',
            ) &&
            state.energy.gatewayDevice?.deviceConfiguration?.hasBeenMigrated
        );
    });

export const useToUReadiness = () =>
    useAppSelector((state) => state.timeOfUse.readiness);
